import { PhoneCubaNumberRuler } from '@dofleini/validator';

import MunicipalitySelect from '@/components/MunicipalitySelect';
import ProvinceSelect from '@/components/ProvinceSelect';
import createClearRenderView from '@/utils/createClearRenderView';
import { renderMunicipality, renderProvince } from '@/utils/location';

export const fields = [
  {
    key: 'name',
    label: 'historianOffices.name.label',
    colSpan: 2,
    required: true,
    className: 'form-view-mode-vertical-item'
  },
  {
    key: 'phone',
    colSpan: 2,
    required: true,
    renderView: createClearRenderView(),
    label: 'historianOffices.phone.label',
    rules: [PhoneCubaNumberRuler]
  },
  {
    key: 'email',
    colSpan: 2,
    label: 'historianOffices.email.label',
    renderView: createClearRenderView(),
    rules: [{ required: true }, { type: 'email' }]
  },
  {
    key: 'address.province',
    label: 'province',
    required: true,
    colSpan: 1,
    widget: ProvinceSelect,
    viewWidget: ({ value }) => renderProvince(value)
  },
  {
    key: 'address.municipality',
    label: 'municipality',
    required: true,
    onlyEdit: true,
    colSpan: 1,
    related: 'address.province',
    relatedKey: 'province',
    widget: MunicipalitySelect
  },
  {
    key: 'address.municipality',
    required: true,
    onlyView: true,
    colSpan: 1,
    label: 'municipality',
    viewWidget: ({ value }) => renderMunicipality(value)
  },
  {
    key: 'address.abstract',
    label: 'address',
    widget: 'textarea',
    widgetProps: { autoSize: { minRows: 2, maxRows: 5 } },
    required: false,
    className: 'form-view-mode-vertical-item'
  },
];
